import { createTheme, LinkProps, CssBaseline, ThemeProvider } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import { type ReactNode, type Ref } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';

type LinkBehaviorProps = Omit<RouterLinkProps, 'to'> & {
  href: RouterLinkProps['to'];
  ref?: Ref<HTMLAnchorElement>;
};

function LinkBehavior({ href, ref, ...other }: LinkBehaviorProps) {
  // Map href (MUI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
}

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: deepPurple[500],
    },
    secondary: {
      main: '#fff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      'Arial',
      'Hiragino Sans',
      'Meiryo',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      } as LinkProps,
    },
  },
});

export const MuiThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {children}
    </ThemeProvider>
  );
};
